'use client';

import useMenuState from './lib/HeaderContent/hooks/useMenuState';
import { NavigationItem } from './lib/HeaderContent/types';
import HeaderBase from '@/core/HeaderBase';
import HeaderContent from './lib/HeaderContent';

export default function MarketingHeader({ navigation }: { navigation: NavigationItem[] }) {
  const menuState = useMenuState();

  return (
    <HeaderBase
      isMarketingWebsite
      onMouseEnter={menuState.cancelCloseTimer}
      onMouseLeave={menuState.scheduleCloseDesktopMenu}
    >
      <HeaderContent navigation={navigation} menuState={menuState} />
    </HeaderBase>
  );
}
